import React from 'react'
import Header from '../containers/Header'
import MainSection from '../containers/MainSection'

const App = () => (
  <div class="main">
    <Header />
    <MainSection />
  </div>
)

export default App
